import PropTypes from 'prop-types';
import Image from 'next/image';
import breakPoints from 'helpers/Styles';
import Link from 'next/link';
import { useState } from 'react';
import useScreenWidth from 'utils/useScreenWidth';

const ProductCardGaming = ({ item, buttonLabel, fixedPrice }) => {
  if (!item.pc_model || !item.featureDoc) return '';
  const {
    featureDoc: {
      data: { features },
    },
    pc_model: { data: pricing },
  } = item;
  const [imageUrl, setImageUrl] = useState(item?.thumbnail?.url || '/images/placeholders/product.png');

  const handleHoverOn = () => {
    if (item?.thumbnail2?.url) {
      setImageUrl(item.thumbnail2.url);
    }
  };
  const handleHoverLeave = () => {
    setImageUrl(item?.thumbnail?.url || '/images/placeholders/product.png');
  };

  const widthSize = useScreenWidth();

  return (
    <div>
      <div className="product_card">
        <div className="product_card_contents">
          <div className="product_title">
            <Link href={item.link || '#'}>
              <a href={item.link || '#'}>{item.title1}</a>
            </Link>
          </div>
          <div className="product_keywords">{item.subtitle}</div>
          <div className="image-container">
            {/* {widthSize <= 990 &&
              <div className='image-background'>
                <div className='bg-image-container darken-image'>
                  <Image draggable={false}
                      src={imageUrl}
                      width={280}
                      height={280}
                    />
                  <div className="overlay"></div>
                </div>
              </div>
            } */}
            {item?.thumbnail2?.url ? (
              <Link href={item.link || '#'}>
                <a href={item.link || '#'} className="view_more">
                  <Image draggable={false}
                    src={imageUrl}
                    alt={item.thumbnail.alt}
                    width={item.thumbnail?.dimensions?.width}
                    height={item.thumbnail?.dimensions?.height}
                    onMouseEnter={handleHoverOn}
                    onMouseLeave={handleHoverLeave}
                  />
                </a>
              </Link>
            ) : (
              <Link href={item.link || '#'}>
                <a href={item.link || '#'} className="view_more">
                  <Image draggable={false}
                    src={imageUrl}
                    alt={item.thumbnail.alt}
                    width={item.thumbnail?.dimensions?.width}
                    height={item.thumbnail?.dimensions?.height}
                  />
                </a>
              </Link>
            )}
          </div>

          <div className="product_features">
            <div className="product_features_item">
              {features.map((feature) => (
                <div className="feature_item" key={feature.label}>
                  <div className="feature_icon">
                    <Image draggable={false}
                      src={feature.icon?.url || '/icons/icon-cpu.svg'}
                      alt={feature.icon?.alt}
                      width={15}
                      height={15}
                    />
                  </div>
                  <div className="feature_title">{feature.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="product_pricing">
          <div className="product_pricing_total">
            <span className="product_pricing_from">
              {fixedPrice ? 'MYR' : 'from MYR'}
            </span>
            <span className="product_pricing_price">
              <span>RM </span>
              {pricing?.base_price &&
                parseFloat(pricing.base_price).toLocaleString()}
            </span>
            <span className="product_pricing_compare_price">
              {pricing?.base_price_compare_at &&
                pricing?.base_price_compare_at !== '0' && (
                  <strike>
                    {parseFloat(pricing.base_price_compare_at).toLocaleString()}
                  </strike>
                )}
            </span>
          </div>
        </div>
        <div className="product_link">
          <Link href={item.link}>
            <a href={item.link} className="view_more">
              {buttonLabel || 'START CUSTOMISING'}
            </a>
          </Link>
        </div>
      </div>
      <style jsx>
        {`
          .feature_item {
            margin-bottom: 10px;
          }
          .product_card {
            width: 312px;
            flex: 1;
          }
          .product_card_contents {
            background: #242424;
            color: #e4e4e4;
            width: 312px;
            border-radius: 4px 4px 0 0;
          }
          .product_title {
            color: #e4e4e4;
            font-family: 'big_noodle_titling';
            font-size: 25px;
            letter-spacing: 0;
            line-height: 32px;
            text-align: center;
            padding-top: 20px;
          }
          .product_keywords {
            color: #949494;
            font-family: 'big_noodle_titling';
            font-size: 18px;
            letter-spacing: 0;
            line-height: 24px;
            text-align: center;
            margin-bottom: 10px;
          }
          .product_benchmarks {
            display: flex;
            color: #949494;
            font-family: 'Roboto-Light';
            font-size: 10px;
            letter-spacing: 0;
            line-height: 16px;
            padding: 20px;
          }
          .benchmark_percentage {
            width: 50px;
            height: 50px;
            margin-right: 25px;
          }
          .benchmark_category {
            width: 50%;
            // display: flex;
            align-items: center;
          }
          .benchmark_text {
            padding-top: 25px;
            padding-left: 10px;
          }
          hr {
            width: 90%;
            border: none;
            height: 1px;
            background-color: #949494;
          }
          .product_features {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            gap: 20px;
            padding: 20px;
          }
          .product_features_item {
            width: 98%;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin: 0 auto;
            gap: 15px;
          }
          .feature_item {
            width: 100%;
            display: flex;
            gap: 10px;
            align-items: center;
            color: #e4e4e4;
            font-family: 'Roboto-Light';
            font-size: 13px;
            letter-spacing: 0;
            line-height: 20px;
            margin-bottom: 10px;
          }
          .feature_title {
            text-align: left;
          }
          .feature_icon {
            margin-top: 5px;
          }
          .product_pricing {
            display: flex;
            flex-direction: column;
            background-color: #141414;
            padding: 30px;
            align-items: center;
            justify-content: center;
            width: 312px;
          }
          .product_pricing_total {
            display: flex;
            gap: 10px;
            align-items: center;
            justify-content: center;
          }
          .product_pricing_from {
            color: #949494;
            font-family: 'Roboto-Light';
            font-size: 13px;
            letter-spacing: 0;
            line-height: 13px;
            text-align: right;
          }
          .product_pricing_price {
            color: #e4e4e4;
            font-family: 'big_noodle_titling';
            font-size: 31px;
            letter-spacing: 0;
            line-height: 40px;
          }
          .product_pricing_compare_price {
            color: #949494;
            font-family: 'Roboto-Light';
            font-size: 16px;
            letter-spacing: 0;
            line-height: 13px;
            text-align: right;
          }
          .product_link {
            background-color: #950810;
            color: #e4e4e4;
            font-family: 'Roboto-Medium';
            font-size: 16px;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 50px;
            height: 50px;
            text-align: center;
            width: 312px;
            border-radius: 0 0 4px 4px;
          }
          .product_link:hover {
            background-color: #800006;
          }
          .view_more {
            display: block;
            width: 100%;
            height: 100%;
          }
          hr {
            background-color: #343434 !important;
          }
          .image-container {
            cursor: pointer;
          }
          .image-container {
            position: relative;
          }
          .bg-image {
            /* The image used */
            background-image: url('photographer.jpg');

            /* Add the blur effect */
            filter: blur(5px);
            -webkit-filter: blur(8px);

            /* Full height */
            height: 100%;

            /* Center and scale the image nicely */
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
          }
          .image-background {
            background-color: #242424;
            width: 100%;
            height: 280px;
            position: absolute;
            overflow: hidden;
          }
          .bg-image-container {
            width: 100%;
            height: 280px;
            position: absolute;
          }
          .bg-image-container .image {
            width: 100%;
            height: 100%;
            position: relative !important;
            object-fit: cover; // Optional
          }
          .darken-image .overlay {
            position: absolute;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgb(0 0 0 / 60%); /* black with 50% opacity */
          }
          @media (max-width: ${breakPoints.medium}) {
            .product_card {
              margin: 0 auto;
            }
            .product_title {
              padding-top: 10px;
              font-size: 20px;
              line-height: 20px;
            }
            .product_keywords {
              font-size: 15px;
              margin-bottom: 5px;
              line-height: 20px;
            }
            .feature_item {
              margin-bottom: 0;
              font-size: 11px;
            }
            .product_features {
              padding: 10px;
            }
            .product_features_item {
              gap: 0;
            }
            .product_pricing {
              padding: 0px;
            }
            .product_pricing_price {
              font-size: 18px;
            }
            .product_pricing_from {
              font-size: 10px;
            }
            .product_pricing_compare_price {
              font-size: 10px;
            }
            .view_more {
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .product_link {
              font-size: 12px;
              height: 35px;
            }
          }
          @media (max-width: ${breakPoints.extraSmall}) {
            .product_card {
              width: auto;
            }
            .product_card_contents {
              width: auto;
            }
            .product_pricing {
              width: auto;
            }
            .product_link {
              width: auto;
            }
          }
        `}
      </style>
    </div>
  );
};

ProductCardGaming.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  item: PropTypes.object.isRequired,
  buttonLabel: PropTypes.string,
  fixedPrice: PropTypes.bool,
};

ProductCardGaming.defaultProps = {
  buttonLabel: 'START CUSTOMISING',
  fixedPrice: false,
};

export default ProductCardGaming;
